import { useState } from 'react'
import ReactGA from 'react-ga4'

import { ObjectSelection } from '@/core/interface/Catalog'
import { useAppDispatch, useAppSelector } from '@/core/store'
import { DEFAULT_TAGS, setFilterChanged, setSelectedCategories } from '@/core/store/catalog.store'
interface CategoryFilterProps {
  onApply: () => void
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({ onApply }) => {
  const { selectedTags } = useAppSelector((store) => store.catalogStore)

  const dispatch = useAppDispatch()

  const [selectedNow, setSelectedNow] = useState<string[]>(selectedTags)
  const names = new Map([
    // ['10', 'Top attractions'],
    // ['7', 'Worth visiting'],
    // ['3', 'Take a look if walking around'],
    // ['5', 'May be interesting'],
    ['building', 'Buildings'],
    ['museum', 'Museums'],
    ['church', 'Churches'],
    ['plaza', 'Plazas'],
    ['monument', 'Monuments'],
    ['O', 'Places'],
    ['B-M', 'Museums&interesting buildings'],
    ['bridge', 'Bridges'],
    ['B-P', '_'],
    ['Area', 'Areas'],
    ['other', 'Other'],
    ['street', 'Streets'],
    ['S-P', 'Monuments and areas'],
    ['X', 'Unknowns'],
    ['T', 'Transport'],
    ['CAFE', 'Cafes *'],
    ['ICE-CR', 'Ice cream-bars *'],
    ['BAR', 'Bars *'],
    ['REST', 'Restaurants *'],
    ['TERR', 'Terraces'],
    ['T', 'Transport'],
  ])

  const icon_types = new Map([
    ['museum', '/img/new/muse.png'],
    ['building', '/img/new/arch.png'],
    ['church', '/img/new/chur.png'],
    ['plaza', '/img/new/plac.png'],
    ['street', '/img/new/plac.png'],
    ['bridge', '/img/new/bidg.png'],
    ['B-P', '/img/new/plac.png'],
    ['B-M', '/img/new/muse.png'],
    ['Area', '/img/new/plac.png'],
    ['monument', '/img/new/scul.png'],
    ['B', '/img/new/arch.png'],
    ['O', '/img/new/star.png'],
    ['other', '/img/new/star.png'],
    ['T', '/img/new/star.png'],
    ['CAFE', '/img/new/cafe.png'],
    ['ICE-CR', '/img/new/ice-cream.png'],
    ['REST', '/img/new/restaurant.png'],
    ['BAR', '/img/new/restaurant.png'],
    ['TERR', '/img/new/terrace.png'],
  ])

  //const categoriesToUse = ['10', '7', '5', '3']
  const objectsToUse = [
    'building',
    'museum',
    'church',
    'monument',
    'plaza',
    'bridge',
    'street',
    'TERR',
    'BAR',
    'CAFE',
    'ICE-CR',
    'REST',
    'other',
  ]

  const getCategoryName = (cat: string) => {
    //TODO: i18n
    const n = names.get(cat)
    return n
  }

  const getCategoryIcon = (cat: string) => {
    //TODO: i18n
    const n = icon_types.get(cat)
    return n
  }

  const applyCategoryChange = () => {
    dispatch(setSelectedCategories(selectedNow))

    //check if current state is different from default
    const sortedSelected = [...selectedNow].sort()
    const sortedDefault = [...DEFAULT_TAGS].sort()
    const isChanged = JSON.stringify(sortedSelected) !== JSON.stringify(sortedDefault)

    dispatch(setFilterChanged(isChanged))

    onApply() // Call the onApply function when categories are applied
    ReactGA.event({
      category: 'click',
      action: 'WA_CategoryApply',
      label: selectedNow.join(','),
    })
  }

  const handleCategoryChange = (category: string) => {
    if (selectedNow?.includes(category)) {
      setSelectedNow(selectedNow?.filter((cat) => cat !== category))
      ReactGA.event({
        category: 'click',
        action: 'WA_CategorySelect',
        label: selectedNow?.filter((cat) => cat !== category).join(','),
      })
    } else {
      setSelectedNow(selectedNow ? [...selectedNow, category] : [category])
      ReactGA.event({
        category: 'click',
        action: 'WA_CategorySelect',
        label: (selectedNow ? [...selectedNow, category] : [category]).join(','),
      })
    }
  }
  // console.log(objectsToUse)
  return (
    <div id={'noClose'} onClick={(e) => e.stopPropagation()} className="filter_modal_frame">
      {/* Picture like icon */}
      {[...objectsToUse].map((category) => (
        <div id={'noClose'} key={category} className={'checkBox'}>
          <img key={category} className="category__image" src={getCategoryIcon(category)}></img>
          <span id={'noClose'} className="box" onClick={() => handleCategoryChange(category)}>
            {selectedNow?.includes(category) && (
              <svg
                id={'noClose'}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="1" y="1.02246" width="16" height="16" rx="2.5" stroke="#B0B0B0" />
                <path
                  id={'noClose'}
                  d="M5 9.17246L8.14286 12.7725L16 3.77246"
                  stroke="#66CFC3"
                  strokeWidth="2"
                />
              </svg>
            )}
            {!selectedNow?.includes(category) && (
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="1" y="1.02246" width="16" height="16" rx="2.5" stroke="#B0B0B0" />
              </svg>
            )}
          </span>
          <p id={'noClose'}>{getCategoryName(category)}</p>
        </div>
      ))}
      <button id={'noClose'} className="apply" onClick={applyCategoryChange}>
        Apply
      </button>
      <p className="category-filter-note">* with culturally and historically <br /> artifacts</p>
    </div>
  )
}

export default CategoryFilter
